import styled from 'styled-components';

const Ol = styled.ol`
  padding: 0;
  margin: 0;
  list-style: none;
`;

export default Ol;
